'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import * as Sentry from '@sentry/nextjs';

const PageTracker = () => {
  const pathname = usePathname();
  const { logger } = Sentry;

  useEffect(() => {
    const timer = setTimeout(() => {
      logger.info(logger.fmt`Page loaded successfully: ${pathname}`, {
        component: 'PageTracker',
        action: 'page_load',
        page_path: pathname,
      });
    }, 1000);

    return () => clearTimeout(timer);
  }, [pathname, logger]);

  return null;
};

export default PageTracker;
